module.exports = __webpack_public_path__ + "img/icon-hide-group-1.870d58ed.svg";